<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/category' }">
        <app-i18n code="entities.category.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.category.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.category.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <app-back-button
      i18n-code="common.back.default"
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.category.edit.title" v-if="isEditing"></app-i18n>
      <app-i18n code="entities.category.new.title" v-if="!isEditing"></app-i18n>
    </h1>

    <div class="app-content-page">
      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <!-- CATEGORY FORM -->
      <category-form :id="id" :manage="currentManage" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CategoryForm from '@modules/category/components/category-form';

export default {
  name: 'CategoryFormPage',

  props: ['id'],

  computed: {
    ...mapGetters({
      findLoading: 'category/form/findLoading',
      currentManage: 'auth/manage/currentManage',
    }),

    isEditing() {
      return !!this.id;
    },
  },

  components: {
    CategoryForm,
  },
};
</script>

<style>
</style>
